import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { copy } from "./copy";

const LANG_KEY = "lang";
const LangContext = createContext(null);

export function getStoredLang() {
  try {
    const value = localStorage.getItem(LANG_KEY);
    return value === "de" || value === "en" ? value : null;
  } catch {
    return null;
  }
}

export function applyLang(lang) {
  document.documentElement.lang = lang;
}

export function persistLang(lang) {
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    // Private browsing can block storage. The language still applies for this visit.
  }
  applyLang(lang);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => (document.documentElement.lang === "de" ? "de" : "en"));

  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", copy[lang].meta);
  }, [lang]);

  const value = useMemo(() => {
    const toggle = () => {
      const next = lang === "de" ? "en" : "de";
      persistLang(next);
      setLang(next);
    };
    return { lang, toggle, t: copy[lang] };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const value = useContext(LangContext);
  if (!value) throw new Error("useLang must be used within LanguageProvider");
  return value;
}
